import type { AccessControlProvider } from '@refinedev/core';

/**
 * Matrice des permissions par rôle.
 * true = accès autorisé, false = accès refusé.
 */
const PERMISSIONS: Record<string, Record<string, boolean>> = {
  ROLE_ADMIN: {
    growth: true,
    'growth/content-factory': true,
    'growth/sales-intelligence': true,
    'growth/knowledge': true,
    'growth/marketing-dashboard': true,
    'growth/content-calendar': true,
    'growth/blog-manager': true,
    'growth/campaigns': true,
    support: true,
    'support/tickets': true,
    'support/users': true,
    ops: true,
    'ops/subscriptions': true,
    'ops/token-watcher': true,
    'ops/quotas': true,
    'ops/pricing': true,
    'admin/pricing': true,
    'admin/dedicated-servers': true,
    tech: true,
    'tech/system-status': true,
    'tech/feature-flags': true,
    'tech/integration-logs': true,
    'tech/prompts': true,
  },
  ROLE_SALES: {
    growth: true,
    'growth/content-factory': true,
    'growth/sales-intelligence': true,
    'growth/knowledge': true,
    'growth/marketing-dashboard': true,
    'growth/content-calendar': true,
    'growth/blog-manager': true,
    'growth/campaigns': true,
    support: true,
    'support/tickets': true,
    'support/users': true,
    ops: true,
    'ops/subscriptions': true,
    'ops/token-watcher': false,
    'ops/quotas': false,
    'ops/pricing': false,
    'admin/pricing': false,
    'admin/dedicated-servers': false,
    tech: false,
    'tech/system-status': false,
    'tech/feature-flags': false,
    'tech/integration-logs': false,
    'tech/prompts': false,
  },
};

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, params }) => {
    const identity = params?.identity as { roles?: string[] } | undefined;
    const roles: string[] = identity?.roles ?? [];

    // ROLE_ADMIN → accès total
    if (roles.includes('ROLE_ADMIN')) {
      return { can: true };
    }

    // ROLE_SALES → vérifier la matrice
    if (roles.includes('ROLE_SALES') && resource) {
      const allowed = PERMISSIONS['ROLE_SALES'][resource];
      return { can: allowed ?? false };
    }

    // Par défaut : accès refusé
    return { can: false, reason: 'Accès non autorisé' };
  },

  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: true,
    },
  },
};
